import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  Panel,
  PanelGroup,
  Section,
  SectionHeader,
} from '@lanl-web/lanl-components';

import EPRRIcon from '../../assets/svg/EPRR.inline.svg';
import FAQIcon from '../../assets/svg/FAQ.inline.svg';
import LAROIcon from '../../assets/svg/LARO.inline.svg';
import PrototypingIcon from '../../assets/svg/prototyping.inline.svg';
import SubjectGuidesIcon from '../../assets/svg/subject-guides.inline.svg';
import ContactUsIcon from '../../assets/svg/contact-us.inline.svg';

import './QuickLinks.scss';

export const QuickLinks = ({ className, title }) => {
  const classes = classNames('quick-links', className);

  return (
    <Section className={classes} backgroundColor='white'>
      <SectionHeader title={title} />
      <PanelGroup className='icon-panel'>
        <Panel
          link='https://research-online.lanl.gov'
          icon={<LAROIcon />}
          title='LARO'
        />
        <Panel link='https://eprr.lanl.gov' icon={<EPRRIcon />} title='EPRR' />
        <Panel
          link='/help-and-tools/subject-guides'
          icon={<SubjectGuidesIcon />}
          title='Subject Guides'
        />
        <Panel
          link='/about-the-library/research-and-prototyping'
          icon={<PrototypingIcon />}
          title='Prototyping'
        />
        <Panel link='/help-and-tools/faq' icon={<FAQIcon />} title='FAQ' />
        <Panel
          link='mailto:library@lanl.gov'
          icon={<ContactUsIcon />}
          title='Contact Us'
        />
      </PanelGroup>
    </Section>
  );
};

QuickLinks.defaultProps = {
  title: 'Quick Links',
};

QuickLinks.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};

export default QuickLinks;
